import { IncidentStatus, IncidentStatusEnum } from '@eppendorf/vnls-notifications-utils';
import { ButtonBase, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { Trans, useTranslation } from 'react-i18next';

import './incident-detail-acknowledge-footer.scss';

type IncidentDetailAcknowledgeFooterProps = {
  canAcknowledge?: boolean;
  acknowledgeIncident: () => void;
  acknowledgingIncident: boolean;
  incidentStatus?: IncidentStatus;
};

export function IncidentDetailAcknowledgeFooter({
  canAcknowledge,
  acknowledgeIncident,
  acknowledgingIncident,
  incidentStatus,
}: IncidentDetailAcknowledgeFooterProps) {
  const { t } = useTranslation();

  const isAcknowledgeableStatus = [
    IncidentStatusEnum.PendingSendNotification,
    IncidentStatusEnum.ActionRequired,
    IncidentStatusEnum.Escalated_1,
    IncidentStatusEnum.Escalated_2,
  ].includes(incidentStatus as IncidentStatusEnum);

  if (!isAcknowledgeableStatus) return null;

  if (!canAcknowledge) {
    return (
      <div
        role="alert"
        className="incident-detail-acknowledge-footer__alert bg-blue-50 border-solid border-color-blue-500 border-radius-xs p-m"
      >
        <div className="flex flex__ai--start gap-s">
          <Icon
            name="notice"
            size={IconSizeClasses.XSmall}
            className="color-white bg-blue-500"
          />
          <p>
            <Trans
              i18nKey="incidents.cannotAcknowledgeIncidentHint"
              components={{ bold: <span className="font-weight-bold" /> }}
            />
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="incident-detail-acknowledge-footer">
      <div className="incident-detail-acknowledge-footer__content">
        <ButtonBase
          onClick={acknowledgeIncident}
          className="btn-base btn btn--primary btn--success btn--medium"
          disabled={acknowledgingIncident}
          title="Acknowledge Incident"
        >
          {t('incidents.acknowledgeIncident')}
        </ButtonBase>
      </div>
    </div>
  );
}
